import React, { memo } from 'react';
import classnames from 'classnames';
import { RouterLink } from '@zmedia/bm-soccer-ui/components/links';
import Element from '../../element';
import styles from './navbar.module.scss';

interface IProps {
    className?: string;
    children: React.ReactNode;
    to: string;
    as: string;
    arrowless?: string;
}

function NavbarLink(props: IProps) {
    const { children, className, to, as, arrowless, ...rest } = props;

    return (
        <Element
            {...rest}
            className={classnames(styles['navbar-link'], className, {
                'is-arrowless': arrowless,
            })}
        >
            <RouterLink to={to} as={as}>
                {children}
            </RouterLink>
        </Element>
    );
}

export default memo(NavbarLink);
